<template>
  <div class="address form-control"
       @click="onClick"
       tabindex="0"
       @focus="open"
  >
    <template v-if="modelValue?.address">
      <span class="value"
            v-tooltip="modelValue.address"
      >
        {{ modelValue.address }}
      </span>


      <input type="hidden" :name="`${parsedName}[id]`" :value="modelValue.id" />
      <input type="hidden" :name="`${parsedName}[lat]`" :value="modelValue.lat" />
      <input type="hidden" :name="`${parsedName}[lng]`" :value="modelValue.lng" />
    </template>
    <template v-else>
      <span class="input-placeholder">
        {{ parsedPlaceholder }}
      </span>
    </template>
  </div>

  <div v-if="!modelValue"
       class="input-group-text"
  >
    <i class="icon-house-o" />
  </div>
</template>
<script setup>
// import AddressModal from "@/js/Elements/AddressModal.vue";
import {useFormControlParser} from "@/js/Elements/Form/FormControl.js";
import {useModal} from "@/js/Plugins/Modal.js";
import {ref} from "vue";
import {useI18n} from "vue-i18n";

const modal = useModal();
const { t } = useI18n();
const emit = defineEmits(['click', 'change']);
const props = defineProps({
  name: String,
  modelValue: Object,
});
const isOpen = ref(false)

const { parsedPlaceholder, parsedName } = useFormControlParser(props, {
  defaultPlaceholder: t('validation.address_placeholder')
});

function onClick(e) {
  emit('click', e);
  open();
}

function open() {
  if (isOpen.value) return;
  isOpen.value = true;
  modal.open(AddressModal, {
    id: 'address',
    address: props.modelValue,
    onSuccess(value) {
      emit('change', value);
      isOpen.value = false;
    },
    onCancel: () => isOpen.value = false
  });
}
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";
.address {
  cursor: pointer;
  overflow: hidden;
}

.value {
  white-space: nowrap;
  width: 100%;
  display: inline-block;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>